import { Platform } from 'react-native';

// Use Google Sans Text across all platforms
// Web: Loaded via Google Fonts CDN in index.html
// Android: Uses downloadable fonts via XML configuration
// iOS: Falls back to San Francisco

export const useAppFonts = () => {
  // Always return true since we're using system/web fonts
  return true;
};

export const fonts = {
  regular: Platform.OS === 'web' 
    ? 'Google Sans Text, Roboto, system-ui, -apple-system' 
    : Platform.OS === 'android' 
      ? 'GoogleSansText-Regular'
      : 'System',
  medium: Platform.OS === 'web' 
    ? 'Google Sans Text, Roboto, system-ui, -apple-system' 
    : Platform.OS === 'android'
      ? 'GoogleSansText-Medium'
      : 'System',
  semiBold: Platform.OS === 'web' 
    ? 'Google Sans Text, Roboto, system-ui, -apple-system' 
    : Platform.OS === 'android'
      ? 'GoogleSansText-Bold'
      : 'System',
  bold: Platform.OS === 'web' 
    ? 'Google Sans Text, Roboto, system-ui, -apple-system' 
    : Platform.OS === 'android'
      ? 'GoogleSansText-Bold'
      : 'System',
};

// Font weights for web and native
export const fontWeights = {
  regular: Platform.OS === 'web' ? '400' : 'normal',
  medium: Platform.OS === 'web' ? '500' : '500',
  bold: Platform.OS === 'web' ? '700' : 'bold',
};

export default fonts;